import React, { useEffect, useState, useRef } from 'react';
import { Box, Grid, Switch, Typography, Button } from '@mui/material';
import JobBoardLeftCustomizer from './JobBoardLeftCustomizer'; // Adjust path as needed
import { useParams } from 'react-router-dom';
import JobBoardPreview from './JobBoardRightPreview';
import './NewJobBoardPortal.css';
import '../JobboardPortal/jobboardportal.css';
import { updateSnackbar } from '../../../_redux/SnackbarSlice';
import { useDispatch } from 'react-redux';
import {
  decrypt,
  encryptParams,
} from '../../../_utilities/_encryptDecryptHelper';
import {
  sessionExpired,
  getApi,
  postApi,
  putApi,
  deleteApi,
} from '../../../_redux/_apiHelpers/_apihelper';

import { GetUserInfo } from '../../../_utilities/getUserInfo';
const NewJobBoardPortal = () => {
  const [segmentData, setSegmentData] = useState([]);
  const [defaultImage, setDefaultImage] = useState(null);

  const dispatch = useDispatch();
  const imgRef = useRef(null);

  const [customerId, setCustomerId] = useState(null);
  useEffect(() => {
    async function init() {
      const userIdData = await GetUserInfo();
      setCustomerId(userIdData[0].customerId);
    }
    init();
  }, []);

  const defaultThemeSettings = {
    primaryColor: '#FFD800',
    secondaryColor: '#3B4046',
    primaryFontColor: '#3B4046',
    secondaryFontColor: '#FFFFFF',
    fontFamily: ['Roboto'],
    logo: '',
    logoPathUrl: '',
    useCustomHeader: false,
    headerBackgroundColor: '#FFFFFF',
    headerTextColor: '#000000',
    isJobPortal: false,
    url: '', //`${process.env.REACT_APP_JOBBOARD_PORTAL_URL}jobfeed/${encryptParams(newQueryParams)}`,
    isEdit: false,
    segmentId: 0,
    segmentName: '',
  };

  useEffect(() => {
    fetchSavedTheme();
  }, [customerId]);

  const fetchSavedTheme = async () => {
    const userIdData = await GetUserInfo();
    try {
      const response = await getApi(
        `/mgmt/customers/jobBoard?atsAdmin=true`,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      const json = response.data;

      if (json.Data?.jobBoard?.length > 0 || json.Data?.segments?.length > 0) {
        const themedData = json?.Data?.jobBoard || [];
        const segments = json.Data?.segments || [];
        let savedTheme = [];
        segments?.forEach((segment) => {
          const theme = themedData?.find(
            (item) => item.segmentId === segment.id
          );

          const newQueryParams = {
            customerId: customerId ? customerId : userIdData[0].customerId,
            segmentId: segment.id,
          };

          if (theme) {
            savedTheme.push({
              ...theme,
              segmentName: segment.segmentName,
              // url: `${process.env.REACT_APP_JOBBOARD_PORTAL_URL}jobfeed/${encryptParams(newQueryParams)}`,
            });
          } else {
            let updateDefaultSettings = { ...defaultThemeSettings };
            updateDefaultSettings.url = `${process.env.REACT_APP_URL}jobboard/jobfeed/${encryptParams(newQueryParams)}`;
            updateDefaultSettings.segmentId = segment.id;
            updateDefaultSettings.segmentName = segment.segmentName;
            savedTheme.push(updateDefaultSettings);
          }
        });
        if (segments.length === 0 && themedData.length === 0) {
          const newQueryParams = {
            customerId: customerId ? customerId : userIdData[0].customerId,
            segmentId: 0,
          };
          savedTheme.push({
            ...defaultThemeSettings,
            url: `${process.env.REACT_APP_URL}jobboard/jobfeed/${encryptParams(newQueryParams)}`,
          });
        } else if (segments.length === 0 && themedData.length > 0) {
          savedTheme = themedData;
        }
        const modifyUpdateData = await Promise.all(
          savedTheme?.map(async (list, index) => {
            const primaryData = list.primaryData
              ? JSON.parse(list.primaryData)
              : [];
            const typographyObj = list.typography
              ? JSON.parse(list.typography)
              : {};
            let logoData = '';

            if (!list?.logo?.includes('s3.ap-south-2.amazonaws.com')) {
              logoData = list?.logo ? await loadLogoPreview(list.logo) : '';
            }

            const getValue = (title) =>
              primaryData.find((item) => item.title === title)?.value;

            list.primaryColor = getValue('PrimaryColor') || list.primaryColor;
            list.secondaryColor =
              getValue('SecondaryColor') || list.secondaryColor;
            list.primaryFontColor =
              getValue('PrimaryFontColor') || list.primaryFontColor;
            list.secondaryFontColor =
              getValue('SecondaryFontColor') || list.secondaryFontColor;
            list.useCustomHeader = getValue('UseCustomHeader') === 'true';
            list.headerBackgroundColor =
              getValue('HeaderBackgroundColor') || list.headerBackgroundColor;
            list.headerTextColor =
              getValue('HeaderTextColor') || list.headerTextColor;
            list.fontFamily = typographyObj.fontName || ['Roboto'];
            list.logo =
              list?.logo?.includes('s3.ap-south-2.amazonaws.com') ||
              list?.logo?.includes('blob:')
                ? list?.logo
                : logoData;
            list.logoPathUrl =
              list?.logo?.includes('s3.ap-south-2.amazonaws.com') ||
              list?.logo?.includes('blob:')
                ? ''
                : list?.logo;
            list.isJobPortal =
              parseInt(list.isJobPortal) || Boolean(list.isJobPortal)
                ? true
                : false;
            list['isEdit'] = false;
            return list;
          })
        );
        setSegmentData(modifyUpdateData);
      } else {
        const newQueryParams = {
          customerId: customerId ? customerId : userIdData[0].customerId,
          segmentId: 0,
        };
        let updateDefaultSettings = { ...defaultThemeSettings };
        updateDefaultSettings.url = `${process.env.REACT_APP_URL}jobboard/jobfeed/${encryptParams(newQueryParams)}`;
        setSegmentData([updateDefaultSettings]);
      }
    } catch (err) {
      console.error('Error loading theme:', err);
      if (err?.response?.status === 405 || err?.response?.status === 406) {
        return sessionExpired(err?.response?.data?.message);
      }
    }
  };

  const loadLogoPreview = async (logoPathUrl) => {
    try {
      if (logoPathUrl && logoPathUrl !== 'null') {
        const updatedUrl = logoPathUrl.replace(/^hirewing1\.0\//, '');
        const res = await postApi(
          `/mgmt/customers/previewDocument?atsAdmin=true`,
          { path: updatedUrl },
          process.env.REACT_APP_USE_MANAGEMENT
        );
        const data = res.data;
        if (data?.path) {
          return data.path;
        }
      }
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
    }
  };

  const generateBlogFile = () => {
    const img = imgRef.current;
    if (!img) return;

    // Create a canvas the size of the natural dimensions of the image
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;

    const ctx = canvas.getContext('2d');
    // Draw the image onto the canvas
    ctx.drawImage(img, 0, 0);

    // Convert the canvas content to a Blob and then to a File object
    canvas.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], 'HireWing.png', { type: 'image/png' });
        setDefaultImage(file);
      }
    }, 'image/png');
  };

  // If the image is cached and already loaded, generate the blog file on mount.
  useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      generateBlogFile();
    }
  }, []);

  const handleSaveTheme = async (logoFile, item) => {
    const formData = new FormData();
    const {
      logoPathUrl,
      primaryColor,
      secondaryColor,
      primaryFontColor,
      secondaryFontColor,
      useCustomHeader,
      headerBackgroundColor,
      headerTextColor,
      fontFamily,
      isJobPortal,
      logo,
      segmentId,
    } = item;
    let { url } = item;
    let updateLogo = logoFile || logoPathUrl || logo; // || defaultImage

    formData.append('logo', updateLogo);

    // Updated: Full primaryData structure
    formData.append(
      'primaryData',
      JSON.stringify([
        { title: 'PrimaryColor', value: primaryColor },
        { title: 'SecondaryColor', value: secondaryColor },
        { title: 'PrimaryFontColor', value: primaryFontColor },
        { title: 'SecondaryFontColor', value: secondaryFontColor },
        { title: 'UseCustomHeader', value: useCustomHeader.toString() },
        { title: 'HeaderBackgroundColor', value: headerBackgroundColor },
        { title: 'HeaderTextColor', value: headerTextColor },
      ])
    );

    // Updated: Typography structure
    formData.append(
      'typography',
      JSON.stringify({
        title: 'FontFamily',
        name: 'fontFamily',
        fontName: fontFamily,
      })
    );
    if (!url || url === 'null') {
      const newQueryParams = { customerId: customerId, segmentId: segmentId };
      url = `${process.env.REACT_APP_JOBBOARD_PORTAL_URL}jobfeed/${encryptParams(newQueryParams)}`;
    }
    formData.append('isJobPortal', isJobPortal ? '1' : '0');
    formData.append('url', url);
    formData.append('customerId', customerId);
    formData.append('segmentId', segmentId);

    try {
      const response = await postApi(
        `/mgmt/customers/jobBoard?atsAdmin=true`,
        formData,
        process.env.REACT_APP_USE_MANAGEMENT,
        true
      );
      const result = response.data;
      dispatch(
        updateSnackbar({
          type: response.status === 200 ? 'success' : 'error',
          message:
            response.status === 200
              ? 'Theme settings saved successfully!'
              : 'Failed to save theme settings.',
        })
      );
      fetchSavedTheme();
    } catch (error) {
      console.error('Error saving theme:', error);
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
    }
  };

  const handleResetTheme = () => {
    let updateSegmentData = [...segmentData];
    let index = updateSegmentData.findIndex((x) => x.isEdit === true);
    if (index !== -1) {
      let updateThemeSettings = { ...defaultThemeSettings };
      updateThemeSettings.segmentId = updateSegmentData[index].segmentId;
      updateThemeSettings.segmentName = updateSegmentData[index].segmentName;
      updateThemeSettings.isJobPortal = updateSegmentData[index].isJobPortal;
      updateThemeSettings.isEdit = updateSegmentData[index].isEdit;
      updateSegmentData[index] = updateThemeSettings;
      if (
        !updateSegmentData[index].url ||
        updateSegmentData[index].url === 'null'
      ) {
        updateThemeSettings.url = `${process.env.REACT_APP_JOBBOARD_PORTAL_URL}jobfeed/${encryptParams({ customerId: customerId, segmentId: updateSegmentData[index].segmentId })}`;
      } else {
        updateThemeSettings.url = updateSegmentData[index].url;
      }
    }
    setSegmentData(updateSegmentData);
  };

  const handleJobPortalToggle = async (e, item) => {
    const checked = e.target.checked;
    const formData = new FormData();
    let updateLogo = item.logo || item.logoPathUrl; // || defaultImage
    formData.append('logo', updateLogo);
    formData.append('isJobPortal', checked ? '1' : '0');
    formData.append('customerId', customerId);
    formData.append(
      'primaryData',
      JSON.stringify([
        { title: 'PrimaryColor', value: item.primaryColor },
        { title: 'SecondaryColor', value: item.secondaryColor },
        { title: 'PrimaryFontColor', value: item.primaryFontColor },
        { title: 'SecondaryFontColor', value: item.secondaryFontColor },
        { title: 'UseCustomHeader', value: item.useCustomHeader.toString() },
        { title: 'HeaderBackgroundColor', value: item.headerBackgroundColor },
        { title: 'HeaderTextColor', value: item.headerTextColor },
      ])
    );
    formData.append(
      'typography',
      JSON.stringify({
        title: 'FontFamily',
        name: 'fontFamily',
        fontName: item.fontFamily,
      })
    );
    if (!item.url || item.url === 'null') {
      const newQueryParams = {
        customerId: customerId,
        segmentId: item.segmentId,
      };
      item.url = `${process.env.REACT_APP_JOBBOARD_PORTAL_URL}jobfeed/${encryptParams(newQueryParams)}`;
    }
    formData.append('url', item.url);
    formData.append('segmentId', item.segmentId);

    try {
      const res = await postApi(
        `/mgmt/customers/jobBoard?atsAdmin=true`,
        formData,
        process.env.REACT_APP_USE_MANAGEMENT,
        true
      );
      const result = res.data;
      dispatch(
        updateSnackbar({
          type: res.status === 200 ? 'success' : 'error',
          message:
            res.status === 200
              ? `Job Board Portal has been ${checked ? 'enabled' : 'disabled'}`
              : 'Failed to update portal status',
        })
      );
      fetchSavedTheme();
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      console.error('Error updating Job Portal status', error);
      dispatch(
        updateSnackbar({
          type: 'error',
          message: 'Error updating Job Portal status',
        })
      );
    }
  };

  const onEditHandler = (list) => {
    let updateSegmentData = [...segmentData];
    let index = updateSegmentData.findIndex(
      (x) => x.segmentId === list.segmentId
    );
    if (index !== -1) {
      updateSegmentData[index].isEdit = true;
    }
    setSegmentData(updateSegmentData);
  };

  const updateSegmentHandler = (type, value, item) => {
    let updateSegmentData = [...segmentData];
    let index = updateSegmentData.findIndex(
      (x) => x.segmentId === item.segmentId
    );
    if (index !== -1) {
      updateSegmentData[index][type] = value;
    }
    setSegmentData(updateSegmentData);
  };

  return (
    <>
      <h3 style={{ marginBottom: 30, marginLeft: '13px' }}>
        Job Board App Preview
      </h3>
      {segmentData?.map((item) => (
        <>
          <img
            src={`${process.env.PUBLIC_URL + '/assests/HireWing.png'}`}
            alt="logo"
            id="defaultLogo"
            ref={imgRef}
            crossOrigin="anonymous"
            onLoad={generateBlogFile}
          />
          <Grid
            container
            spacing={2}
            className="jobboard-portal segmentSection"
          >
            {item?.isEdit && (
              <Grid item xs={12} md={4}>
                <JobBoardLeftCustomizer
                  settings={item}
                  segmentHandler={(type, value) =>
                    updateSegmentHandler(type, value, item)
                  }
                  handleSave={(logoFile) => {
                    handleSaveTheme(logoFile, item);
                  }}
                  handleReset={handleResetTheme}
                />
              </Grid>
            )}
            <Grid key={item.segmentId} item xs={12} md={item.isEdit ? 8 : 12}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '16px',
                }}
              >
                <h3 style={{ margin: 0 }}>{item.segmentName}</h3>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  {!item.isEdit && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography variant="subtitle1">
                        {/* {item.isJobPortal
                          ? 'Disable Job Board Portal'
                          : 'Enable Job Board Portal'} */}
                        Enable Job Board Portal
                      </Typography>

                      <Switch
                        checked={item.isJobPortal}
                        onChange={(e) => handleJobPortalToggle(e, item)}
                        className={
                          item.isJobPortal ? 'activeBtn' : 'inActiveBtn'
                        }
                      />
                    </Box>
                  )}

                  {item.isJobPortal && !item.isEdit && (
                    <Button
                      variant="contained"
                      size="small"
                      className="btn-edit-theme"
                      onClick={() => onEditHandler(item)}
                      disabled={segmentData.some((list) => list.isEdit)}
                    >
                      Edit
                    </Button>
                  )}
                </Box>
              </div>
              <JobBoardPreview settings={item} />
            </Grid>
          </Grid>
        </>
      ))}
    </>
  );
};

export default NewJobBoardPortal;
